import * as yup from 'yup';

export const sqlServerValidationSchema = yup.object().shape({
  '@id': yup.string(),
  name: yup
    .string()
    .required('Name is required')
    .matches(
      /^[a-zA-Z_$][a-zA-Z0-9_$]*$/,
      'Name must start with a letter or underscore and contain only letters, numbers, and underscores'
    ),
  type: yup.string().default('sqlServer'),
  delayedRead: yup.boolean(),
  parameterizedBy: yup.string(),
  format: yup.string(),
  connectionKey: yup.string(),
  properties: yup
    .object()
    .shape({
      databaseName: yup.string(),
      driver: yup.string(),
      sqlQuery: yup.string(),
      host: yup.string(),
      port: yup
        .number()
        .nullable()
        .transform((v) => (v === '' ? null : v)),
      username: yup.string(),
      password: yup.string(),
      parameters: yup.string(),
      procedureName: yup.string(),
    })
    .required(),
});
